import '@fpsm/cxy-tokens/tokens.css';

import { useLoaderData } from 'react-router';

import { type Logos } from '~/routes/$/constants/logos';

import type { loader } from '../../loader.server';
import { LogoImage } from '../LogoImage/LogoImage';

import styles from './LandingPageHeader.module.css';

export type LandingPageHeaderProps = {
  ctaText: string;
  ctaUrl: string;
  logo: Logos;
  logoUrl: string;
};

export const LandingPageHeader = ({ ctaText, ctaUrl, logo, logoUrl }: LandingPageHeaderProps) => {
  const { currentPathWithRepub, resourcesUrl } = useLoaderData<typeof loader>();

  const signupWidgetContainerElementId = ctaUrl;

  return (
    <header className={styles.header}>
      <a className={styles.logo} href={logoUrl}>
        <LogoImage logoName={logo} resourcesUrl={resourcesUrl} />
      </a>
      <a className={styles.cta} href={`${currentPathWithRepub}${signupWidgetContainerElementId}`}>
        {ctaText}
      </a>
    </header>
  );
};
